import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Autocomplete } from '@chegg-ui/autocomplete';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { clearDropdownReset, resetCitiesData, setCityFlags, updatedCountry } from '../../redux/UserAddressState/UserAddressState.slice';
import { ChevronIcon } from '@chegg-ui/theme';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { filterOptionList, addressStateSelector, getFlagIcon, getSanitizedInput } from './helpers';
var AutocompleteWrapper = function AutocompleteWrapper(_ref) {
  var value = _ref.value,
    icon = _ref.icon,
    localizedCountryList = _ref.localizedCountryList,
    onDropdownChange = _ref.onDropdownChange,
    error = _ref.error,
    labelText = _ref.labelText,
    placeholder = _ref.placeholder,
    onDropdownBlur = _ref.onDropdownBlur,
    disabled = _ref.disabled;
  var ref = useRef(null);
  var name = 'country_dropdown';
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = useState(localizedCountryList),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredCountries = _useState4[0],
    setFilteredCountries = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var dispatch = useDispatch();

  // As we track errors and Icons onInputChange, onInputBlur through redux
  // Doesn't want to change Chegg UI's onInputValue hook
  var _useSelector = useSelector(addressStateSelector, shallowEqual),
    userAddressState = _useSelector.userAddressState,
    flagUrl = _useSelector.flagUrl;
  var _userAddressState$cou = userAddressState.country,
    countryCode = _userAddressState$cou.countryCode,
    countryName = _userAddressState$cou.countryName,
    isReset = _userAddressState$cou.isReset;
  var showSuggestions = userAddressState.cityFlags.showSuggestions;
  useEffect(function () {
    value && setInputValue(value);
    if (isReset) {
      setInputValue('');
      dispatch(clearDropdownReset());
    }
  }, [value, isReset]);
  useEffect(function () {
    setFilteredCountries(filterOptionList(localizedCountryList, inputValue, countryCode));
  }, [inputValue]);
  var onInputChange = useCallback(function (value) {
    var _ref$current;
    setInputValue(value);
    // Dispatching each change to redux to maintain states
    dispatch(updatedCountry({
      countryName: getSanitizedInput(value),
      countryCode: '',
      error: true,
      // set to true to not fire callback on every single letter for input
      countrySource: undefined
    }));

    // resetCitiesData set address validation response to initial State
    dispatch(resetCitiesData());

    // focus the input when value is changed on using saved address in browser
    if (!open) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }, [setInputValue, dispatch]);
  var handleInputSelection = useCallback(function () {
    // If no name, code in redux than callback onDropdownBlur function
    if (!countryCode || !countryName) {
      onDropdownBlur(true, countryName);
    }
    // onBlur if city dropdown is open show error
    if (showSuggestions) {
      dispatch(setCityFlags({
        error: true
      }));
    }
    setOpen(false);
  }, [countryCode, countryName, showSuggestions, onDropdownBlur, dispatch]);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault(); // prevent submit event from bubbling up to payment methods form
    handleInputSelection();
  };
  return /*#__PURE__*/React.createElement(Autocomplete, {
    ref: ref,
    disabled: disabled,
    "data-test": DataTestAttributes.COUNTRY_DROPDOWN,
    labelText: labelText,
    options: filteredCountries,
    "aria-labelledby": name + '_label ' + name + '_button',
    name: name,
    value: inputValue,
    placeholder: placeholder,
    onInputChange: onInputChange,
    onInputBlur: handleInputSelection,
    onInputFocus: function onInputFocus() {
      return setOpen(true);
    },
    onSelect: function onSelect(index) {
      return onDropdownChange(filteredCountries[index]);
    },
    onSubmit: handleSubmit,
    inputId: name + '_button',
    errorText: error,
    maxListboxHeight: '200px',
    leadingIcon: getFlagIcon({
      icon: icon,
      value: value,
      inputValue: inputValue,
      flagUrl: flagUrl
    }),
    "data-recurly": "country",
    "data-recurly-country-code": countryCode,
    trailingIcon: /*#__PURE__*/React.createElement(ChevronIcon, {
      id: 'icon-story-Caret',
      role: 'img',
      "aria-hidden": true,
      iconFill: "fill",
      pointing: open ? 'up' : 'down'
    }),
    "aria-invalid": !!error
  });
};
export default AutocompleteWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/internal/AutocompleteWrapper/AutocompleteWrapper.js
// module id = 4504
// module chunks = 11